<template>
  <div class="wt-container">
    <div class="row">
        <div class="col-md-12">
            <p class="introduction-text">
                This pie chart shows the largest sectors and crops in {{assessment.getCountryOrBasinName()}}, in term of their annual {{assessment.viewColor}} water footprint. All other sectors and crops in {{assessment.getCountryOrBasinName()}}, below the threshold, are included in "Other". 
            </p>
            <CountryOrBasinSelector/>
            <div>
                <label>Threshold:
                  <input type="number" value="5" min="1" max="10" step="1" @change="setThreshold" class="threshold">
                  <span class="threshold-appender">%</span>
                </label>
            </div>
            <PieChart :id="'blue-pie-chart'" :color="assessment.viewColor" :data="data" :attrName="attributeName"></PieChart>
        </div>
    </div>
  </div>
</template>

<script>
import { assessment } from "@/services/assessment-model.js"
import CountryOrBasinSelector from "@/components/shared/CountryOrBasinSelector.vue"
import { countryCropsByCountry, basinCropsByBasin, worldCrops } from "@/services/entity-model.js"
import PieChart from "@/components/shared/PieChart.vue"
import * as _ from 'lodash'

export default {
    name: "PieChartCt",
    data() {
        return {
            assessment: assessment,
            countryCropsByCountry: countryCropsByCountry,
            basinCropsByBasin: basinCropsByBasin,
            threshold: 0.05
        }
    },
    components: {
        PieChart,
        CountryOrBasinSelector
    },
    methods: {
        setThreshold: function(val) {
            this.threshold = val.target.value / 100;
        }
    },
    computed: {
        data: function() {
            const crops = (assessment.assessmentType.name == "countries")? this.countryCropsByCountry: (assessment.assessmentType.name == "basins")? this.basinCropsByBasin: worldCrops;
            const filteredCrops = _.filter(crops, (o) => o[this.attributeName.percent] >= this.threshold );
            const otherCrops = _.filter(crops, (o) => o[this.attributeName.percent] < this.threshold);
            const data = _.map(filteredCrops, e => _.pick(e, ["cropName", this.attributeName.percent, this.attributeName.value]));
            const otherWF = _.sumBy(otherCrops, this.attributeName.value);
            if (otherWF > 0) {
                const other = { cropName: "Other" };
                other[this.attributeName.percent] = _.sumBy(otherCrops, this.attributeName.percent);
                other[this.attributeName.value] = parseFloat(otherWF.toPrecision(2));
                data.push(other);
            } else if (filteredCrops.length == 0) {
                const noData = { cropName: "No data available" };
                noData[this.attributeName.percent] = 1;
                noData[this.attributeName.value] = 0;
                data.push(noData);
            }
            return data;
        },
        attributeName: function() {
            const color = this.assessment.viewColor;
            return { percent: `${color}WFFraction`, value: `${color}WF`};
        }
    }
}
</script>

<style lang="scss" scoped>
.threshold {
    width: 80px;
    margin: 0 0 0 8px;
    border: 1px solid grey;
    border-radius: 5px;
    padding: 3px 12px;
    background-color: #fff;
}

.threshold-appender {
    display: inline-block;
    margin-left: -5px;
    border: 1px solid grey;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 3px 5px 3px 9px;
    background-color: #efeee9;
}
</style>
